import { useQuery } from "@tanstack/react-query";

import { ICustomMedication } from "../../../@types/admin/AdminMedication";
import { customMedicationsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export const CUSTOM_MEDICATIONS_QUERY_KEY = "admin-custom-medications";

const EMPTY_CUSTOM_MEDICATIONS: ICustomMedication[] = [];

/** One hospital's custom medications, active and inactive (EN-5240). Idle until a hospital is chosen. */
export function useCustomMedications(hospitalGroupId: number | undefined) {
  const { data, isLoading, isError } = useQuery<ICustomMedication[]>({
    queryKey: [CUSTOM_MEDICATIONS_QUERY_KEY, hospitalGroupId],
    queryFn: async () =>
      ensureOk(
        await customMedicationsService.getCustomMedications(hospitalGroupId!)
      ),
    enabled: hospitalGroupId !== undefined,
    refetchOnMount: "always",
  });

  return {
    customMedications: data ?? EMPTY_CUSTOM_MEDICATIONS,
    isLoading,
    isError,
  };
}
